<template lang="pug">
    .container
      include ResourcesType.pug
</template>

<script>
import { mapState } from 'vuex'
import _ from "underscore"
import Api from "@/components/services/Api";
import PrivateRouterLink from '@/directives/PrivateRouterLink'


export default {
  name: 'ResourcesType',
  components: {PrivateRouterLink},
  props: [
    'slug'
  ],
  computed: mapState([
    "token",
    "context",
  ]),
  data () {
    return {
      limit: 8,
      page: 1,
      hasPrevious: false,
      hasNext: true,
      totalPages: 1,
      pages: [],
      resources: [],
      tree: {
        topics: [],
        families: [],
      },
      selectedTopic: null,
      selectedFamily: null,
      query: "",
      plan: null,
    }
  },
  async created() {
    const _this = this
    let filters = this.buildFilters()
    if (this.slug) this.selectedFamily = this.slug

    // Me information
    const meResponse = await Api.me(this.token)
    const dataMe = meResponse.data
    const plan = dataMe.plan
    this.plan = plan

    // Resources information
    const resourceResponse = await this.$wagtail.getResourceTree()
    const data = resourceResponse.data

    this.tree.topics = data.topics
    this.tree.families = data.families
    this.search()
  },
  methods: {
    isVisible(resource) {
      switch (this.plan) {
        case "basic":
          return resource.on_basic
        case "estandar":
          return resource.on_estandar
        case "premium":
          return resource.on_premium
      }
      return false
    },
    nextPage() {
      if (!this.hasNext) return false
      this.page += 1
      this.search()
    },
    prevPage() {
      if (!this.hasPrevious) return false
      this.page -= 1
      this.search()
    },
    toPage(page) {
      this.page = page
      this.search()
    },
    search() {
      const _this = this
      let filters = this.buildFilters()
      this.resources = []

      _this.$wagtail.getResources(_this.limit, filters).then(response => {
        let data = response.data

        _this.resources = data.results

        _this.hasPrevious = data.has_previous
        _this.hasNext = data.has_next
        _this.totalPages = data.pages

        let pagesList = []

        for (var i = 1; i <= _this.totalPages; i++) {
          pagesList.push(i)
        }
        _this.pages = pagesList
      }).catch(err => {
      })
    },
    buildFilters() {
      let filters = {page: this.page}

      if (this.query && this.query.length) filters.query = this.query
      if (this.selectedTopic) filters.topic = this.selectedTopic
      if (this.selectedFamily) filters.family = this.selectedFamily

      return filters
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";

@include breakpoint($breakpoint-mobile) {
  .form-div.select select {
    width: 80%;
  }

  // .form-blocks label {
  //     display: none;
  // }
}

.formularios-busqueda {
  margin-top: 1rem;
  margin-bottom: 4.5rem;

  select {
    border: 1px solid #fff;
  }

  input {
    padding: 0.4rem;
  }
}

.form-blocks {
  margin: 1rem 0;

  > div {
    width: 33%;
  }
}

@include breakpoint($breakpoint-tablet) {
  .formularios-busqueda {
    display: block;
    margin-top: 0;
    margin-bottom: 3rem;
  }

  .form-blocks > div {
    width: 100%;
  }
}

.article h3.title-article {
  padding-bottom: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/resources/ResourcesType.vue